//
// Copyright (c) 2011-2017 by Curalate, inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('confirmationModal', [
    function() {
      return {
        restrict: 'E',
        transclude: 'true',
        scope: {
                    // Typically just $close(result), but needs to be passed in since this is an isolated scope directive.
                    // This is never passed a result.
          close: '&',
                    // Text for the "no" option
          cancelText: '=?',
                    // Text for the submit/confirm option
          confirmText: '=',
                    // Text in case of an error,
          errorText: '=',
                    // Title of the modal
          modalTitle: '=',
                    // Method to call when submit is called. Format like "submitAction(result)" if submitParam is used.
                    //  If "submitAsync", then it should return a Promise
          submitAction: '&',
                    // True/false value for whether submit triggers an async action (which will have a loading spinner until it completes)
          submitAsync: '=',
                    // Parameter to pass through to submitAction
          submitParam: '=',
                    // Expression to disable the submit button with
          submitDisabled: '=?',
                    // Button class for the submit button
          submitBtnClass: '@?',
                    // Modal size
          modalSize: '@',
          hideCancelButton: '<',
        },
        template: require('@partials/confirmation-modal.html'),
        controller: ['$scope',
          function($scope) {
            $scope.model = {
              cancelText: $scope.cancelText || 'Cancel',
              confirmText: $scope.confirmText,
              errorText: $scope.errorText,
              title: $scope.modalTitle,
              submitBtnClass: $scope.submitBtnClass || 'cu-button-primary',
              hideCancelButton: $scope.hideCancelButton,
              outstandingAsyncAction: '',
            };

            $scope.model.close = function() {
              $scope.close({ result: true });
            };

            $scope.model.submit = function() {
              let asyncPromise;
              if ($scope.submitAsync) {
                $scope.model.outstandingAsyncAction = 'submitAsyncAction';
                asyncPromise = $scope.submitAction({ result: $scope.submitParam });
                asyncPromise.then(() => {
                  $scope.model.close(true);
                }).catch(() => {
                  $scope.model.hasError = true;
                }).finally(() => {
                  $scope.model.outstandingAsyncAction = null;
                });
              } else {
                $scope.submitAction({ result: $scope.submitParam });
                $scope.model.close();
              }
            };
          },
        ],
      };
    },
  ]);
})();
